import React from 'react';

const TermsCondition = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#041a0f] via-[#03140c] to-[#010604] text-white pt-32 pb-20 px-6 font-sans relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-1/4 translate-x-1/2 w-[500px] h-[500px] bg-gradient-to-tl from-[#eddca6]/5 to-transparent rounded-full filter blur-[140px] pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <h1 className="text-4xl md:text-5xl font-serif font-black text-[#eddca6] tracking-widest mb-12 border-b border-[#eddca6]/20 pb-6">
          Terms & Conditions
        </h1>
        
        <div className="space-y-10 text-white/80 font-light leading-relaxed">
          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">1. Agreement to Terms</h2>
            <p>
              By accessing our website and utilizing our services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services. These terms apply to all visitors, users, and others who access or use the Service.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">2. Products and Services</h2>
            <p>
              Chirayil Gold and Diamonds strives to ensure that all details, descriptions, and prices of products appearing on the website are accurate. However, errors may occur. If we discover an error in the price or description of any goods which you have ordered, we will inform you of this as soon as possible and give you the option of reconfirming your order at the correct price or cancelling it.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">3. Pricing and Payments</h2>
            <ul className="list-disc pl-5 space-y-2 text-white/70">
              <li>All prices are inclusive of GST as applicable.</li>
              <li>Gold rates are subject to daily market fluctuations. The final price at the time of purchase will apply.</li>
              <li>We accept various modes of payment including credit/debit cards, net banking, and UPI. All transactions are securely processed.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">4. Gold Savings Schemes</h2>
            <p>
              Participation in any of our Gold Savings Schemes is subject to specific terms and conditions provided at the time of enrollment. Scheme deposits are non-refundable in cash and can only be redeemed against jewellery purchases as per the scheme guidelines.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">5. Intellectual Property</h2>
            <p>
              The design, layout, look, appearance, and graphics of our jewellery and website are owned by or licensed to Chirayil Gold and Diamonds. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">6. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion. We recommend checking this page periodically for updates.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
